import React from "react";
import PropTypes from "prop-types";

export default function DeploymentTargetCard({ value, selected, onChange, title, description }) {
  return (
    <label
      className={[
        "flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-colors duration-150",
        selected
          ? "border-[var(--jade-blue-700)] bg-[var(--jade-blue-50)]"
          : "border-gray-200 bg-white hover:border-gray-300",
      ].join(" ")}
    >
      <input
        type="radio"
        name="target"
        value={value}
        checked={selected}
        onChange={onChange}
        className="mt-0.5 accent-[var(--jade-blue-700)] flex-shrink-0"
      />
      <div>
        <p className="text-sm font-semibold text-slate-800">{title}</p>
        <p className="text-xs text-slate-500 mt-1 leading-relaxed">{description}</p>
      </div>
    </label>
  );
}

DeploymentTargetCard.propTypes = {
  value:       PropTypes.string.isRequired,
  selected:    PropTypes.bool.isRequired,
  onChange:    PropTypes.func.isRequired,
  title:       PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
